import BaseApiInstance from './base';
const BASE_URL = '/team-tag';

export const getTeamTagsApi = async params => {
  const response = await BaseApiInstance.get(`${BASE_URL}`, {
    params,
  });
  return response;
};

export const createTeamTagApi = async data => {
  const response = await BaseApiInstance.post(`${BASE_URL}`, data);
  return response;
};

export const updateTeamTagApi = async (id, data) => {
  const response = await BaseApiInstance.put(`${BASE_URL}/${id}`, data);
  return response;
};

export const deleteTeamTagApi = async id => {
  const response = await BaseApiInstance.delete(`${BASE_URL}/${id}`);
  return response;
};
